import { GenericElement } from "./Elements/GenericElement";
import { KitchenStyle } from "./Elements/KitchenStyle";
import { StorageElementDepth } from "./Elements/StorageElementDepth";
import { StorageElementHeight } from "./Elements/StorageElementHeight";
import { StorageElementType } from "./Elements/StorageElementType";
import { FilterGroup } from "./Tools/FilterGroup";
import { WidgetFactory } from "./Tools/WidgetFactory";
import * as SavaneJS from "@rhinov/savane-js";
import * as noUiSlider from 'nouislider';
import { FiltersController } from "./Tools/FiltersController";
import { ObjectTypeFilter } from "./Filters/ObjectTypeFilter";
import { KitchenTypeFilter } from "./Filters/KitchenTypeFilter";
import { KitchenFilterWidget } from "./FiltersWidgets/KitchenFilterWidget";
import { StorageFilterWidget } from "./FiltersWidgets/StorageFilterWidget";
import { BathRoomFilterWidget } from "./FiltersWidgets/BathroomFilterWidget";
import { CamerasFilterWidget } from "./FiltersWidgets/CamerasFilterWidget";
import { LightsFilterWidget } from "./FiltersWidgets/LightsFilterWidget";

declare var AssetManagerServices: any;
declare var DecorationService: any;
declare var Savane: any;
declare const HP_CONFIG: any;
declare var PlanManager: any;
declare var ActionStateEnum: any;

export class FiltersWidget {

    static controller: FiltersController | null = null;
    static $routeParams?: any;
    static user?: any;
    static designer?: any;
    static enable_additionals_afters: boolean = true;
    static contentFactory: boolean = false;
    static deliverable?: any;
    static openPreviewFunc?: Function
    static cacheLights: any[] = [];
    static cacheCameras: any[] = [];
    static ArrangementType: typeof SavaneJS.SceneConstants.ArrangementType = SavaneJS.SceneConstants.ArrangementType;
    static OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS: string = '&fields=kind,marketName,price,genericName,name,customizationGroups,randomization,dimensions,displayDimensions,sketchBlock,_id,marketLink,configs,colors,stretchability,objectType,type,manufacturer,retailer,pipeline.quality,pipeline.state,pipeline.modelState,styles,marketStatus,saleState';
    static commandListener: any;
    static projectReloadListener: any;
    static tulipActionListener: any;

    static getDecorationService() {
        if (DecorationService.getInstance === undefined) {
            return DecorationService.DecorationService.getInstance();
        } else return DecorationService.getInstance();
    }
    // Listener to load next proposals of objects
    static designerFiltersNextObjects = Savane.eventsManager.instance.addListener(Savane.Events.DESIGNER_FILTERS_NEXT_OBJECTS, function (event: any) {
        FiltersWidget.getDecorationService().setFilters('nextobjects', JSON.stringify(event.userData));
    });

    static webGLActiveCameraListener = Savane.eventsManager.instance.addListener(Savane.Events.WEBGL_ACTIVE_CAMERA, function (event) {
        var data = event.getUserData();

        if (data.entity.cameraType === Savane.SceneConstants.CameraType.Panoramic) {
            FilterGroup.previewCameraId = -2;
        }
        else {
            FilterGroup.previewCameraId = data.entity.id;
        }
    });

    static webGLFreeCameraListener = Savane.eventsManager.instance.addListener(Savane.Events.WEBGL_FREE_CAMERA, function (event) {
        var data = event.getUserData();
        FilterGroup.freeCamera = data.camera;
        FilterGroup.previewCameraId = -1;
    });

    static keyDownListener: ((event: KeyboardEvent) => void) | null = null;


    // Last object type send to set filter from cocos or webGL views
    static lastObjectType: any | null = null;
    static furnitures: any[] = [];

    static filterGroups: FilterGroup[] = [];
    static currentFiltersGroup: FilterGroup | null = null;

    static kitchenStyles: KitchenStyle[] = [
        new KitchenStyle('Ixina Lisse', 'IX_blank'),
        new KitchenStyle('Ixina gouttière Line-N', 'IX_gutter_line-N'),
        new KitchenStyle('Ixina cadre Delia', 'IX_frame_delia'),
        new KitchenStyle('Ixina cadre Suède', 'IX_frame_suede'),
    ];

    static kitchenElements: GenericElement[] = [
        new GenericElement('Tout', null, null),
        new GenericElement('Ixina Lisse', 'DoorType', 'IX_blank'),
        new GenericElement('Ixina gouttière Line-N', 'DoorType', 'IX_gutter_line-N'),
        new GenericElement('Ixina cadre Delia', 'DoorType', 'IX_frame_delia'),
        new GenericElement('Ixina cadre Suède', 'DoorType', 'IX_frame_suede'),
        new GenericElement('Ixina étagères', 'DoorType', 'IX_none'),
        new GenericElement('Ixina pieds', 'ObjectType', '5fb4e71dd383f578dd30217f'),
        new GenericElement('Hottes', 'ObjectType', '5c34c7ecf48dcd3807285466'),
        new GenericElement('Micro-Ondes', 'ObjectType', '5c34c1435c1a73382bc54c5e'),
        new GenericElement('Réfrigerateur', 'ObjectType', '58c129d9178b09562a342ff9'),
        new GenericElement('Réfrigerateur bas', 'ObjectType', '5c34c0cc96634b38261ca95d'),
        new GenericElement('Cave à vin', 'ObjectType', '5c34cbb8a24b85380cc236bb'),
        new GenericElement('Laves vaisselle', 'ObjectType', '5c34c11ef48dcd380728545c'),
        new GenericElement('Laves linge', 'ObjectType', '5c34c0ed96634b38261ca95f'),
        new GenericElement('Sèche linges', 'ObjectType', '5c34c15f40a01538237a4569'),
        new GenericElement('Tables de cuissons', 'ObjectType', '58bfe35826a00f3d9dfecb5b'),
    ];

    static bathroomElements: GenericElement[] = [
        new GenericElement('Tout', null, null),
        new GenericElement('Lapeyre Fabian', 'CollectionType', '667c305f979b18342764f6a5'),
        new GenericElement('Lapeyre Faustine', 'CollectionType', '643e8e00a58e4903ef896d7e'),
        new GenericElement('Lapeyre Ferguson', 'CollectionType', '643e8dbf411baa037d1e2dda'),
        new GenericElement('Lapeyre Flavio', 'CollectionType', '61f7ea7138a6251833d4d15a'),
        new GenericElement('Lapeyre Flora', 'CollectionType', '63edf5e80ea9f103ec0eba06'),
        new GenericElement('Lapeyre Fokus 2', 'CollectionType', '63ee051b5e657a03dba26e4d'),
        new GenericElement('Lapeyre Formeo', 'CollectionType', '67af4d4b3efde6418745b0c9'),
        new GenericElement('Lapeyre Frann', 'CollectionType', '667c305fdbcc94343ffe7b2b'),
        new GenericElement('Lapeyre Frida', 'CollectionType', '63f778234dbddc04178fb97e'),
        new GenericElement('Lapeyre Happy 2', 'CollectionType', '61f7ea71599288182bdd3519'),
        new GenericElement('Lapeyre Infiny', 'CollectionType', '605b6af7207a19212f22a24d'),
        new GenericElement('Lapeyre Irresistible', 'CollectionType', '63ee051b0ea9f103ec0ec3b8'),
        new GenericElement('Lapeyre Phileas', 'CollectionType', '61f7ea71969e3517ef53f9a8'),
        new GenericElement('Lapeyre Metal', 'CollectionType', '5fd34e27021e50421176021a'),
        new GenericElement('Lapeyre Metal 2', 'CollectionType', '667c3030cd26b233d9a27f34'),
        new GenericElement('Lapeyre Phoenix', 'CollectionType', '667c305f80235534397d6cbf'),
        new GenericElement('Lapeyre Ytrac', 'CollectionType', '5fd34e432e211142360983ec'),
        new GenericElement('Plan de toilette', 'CollectionType', '5bc06e68be6c755c1fb2d5e7'),
        new GenericElement('Robinets', 'CollectionType', '5bc06f3cd08ceb5c26f750cb'),
        new GenericElement('Lapeyre Priva', 'CollectionType', '667c305f979b18342764f6a6'),
        new GenericElement('WC / bidets', 'ObjectType', '5bc06ff5fc81215c3e9b98d1'),
        new GenericElement('Saunas', 'ObjectType', '5bc06f5de94f625c082226b9'),
        new GenericElement('Armoire de WC', 'ObjectType', '5bc06ce4038c865c16041a66'),
        new GenericElement('Parois de douches', 'ObjectType', '5bc06e3dfc81215c3e9b98cb'),
        new GenericElement('Laves mains', 'ObjectType', '5bc06db6d103a35c134d6c19'),
        new GenericElement('Receveurs', 'ObjectType', '5bc06f154772d35c2d8839ea'),
        new GenericElement('Plans vasques', 'ObjectType', '5bc06e98008fef5c0a7e3f33'),
        new GenericElement('Sèches mains', 'ObjectType', '5bc06f81d08ceb5c26f750cd'),
        new GenericElement('Lavabos', 'ObjectType', '5bc06d924706b05c32efd8c7'),
        new GenericElement('Meubles sous vasques', 'ObjectType', '5bc06df64772d35c2d8839e6'),
        new GenericElement('Vasques', 'ObjectType', '5bc06fd7038c865c16041a68'),
        new GenericElement('Rangements', 'ObjectType', '5bc06ef4fc81215c3e9b98cd'),
        new GenericElement('Sèches serviettes', 'ObjectType', '60dd8cd3b0d1f35c02391d09'),
        new GenericElement('Douches', 'ObjectType', '5bc06d6fefe98c5c27d0a811'),
        new GenericElement('Colonnes', 'ObjectType', '5bc06d434706b05c32efd8c5'),
        new GenericElement('Portes serviettes', 'ObjectType', '5bc06ed04772d35c2d8839e8'),
        new GenericElement('Pares baignoires', 'ObjectType', '5bc06e19d103a35c134d6c1b'),
        new GenericElement('Ensemble', 'ObjectType', '5d1f1910977741717a9e8f00'),
        new GenericElement('Meubles haut', 'ObjectType', '5a743d3af299274c61ac69bd'),
        new GenericElement('Pieds', 'ObjectType', '5a746488f299274c61ac69c1'),
        new GenericElement('Etagères de salle de bain', 'ObjectType', '5a6ef1d76bde096d6e447623'),
        new GenericElement('Meuble bas', 'ObjectType', '5bc06dd44772d35c2d8839e4'),
        new GenericElement('Baignoires', 'ObjectType', '5bc06d08be6c755c1fb2d5e5'),
        new GenericElement('Tabliers baignoires', 'ObjectType', '5f2d0e8a52c15644da70f4ea'),
        new GenericElement('Porte de douche', 'ObjectType', '5f51f74ee23c0d6f78b5f548'),
        new GenericElement('Miroir de salle de bain', 'ObjectType', '5f562dcd49357e143aa42717'),
        new GenericElement('Poignées', 'ObjectType', '5f6b6699e9de7056bb9155d1'),
        new GenericElement('Personnes Mobilité Réduite', 'ObjectType', '655f199d6f79e7f7685715f3'),
    ];

    static couchElements: GenericElement[] = [
        new GenericElement('Tout', null, null),
        new GenericElement('ASTUS - Gris chiné', 'CollectionType', '64479f07b875a2511c726efc'),
        new GenericElement('BARACK - Velours Marbré Gris Foncé', 'CollectionType', '64479f07b875a2511c726f24'),
        new GenericElement('BARACK - Velours Marbré Vert', 'CollectionType', '64479f07b875a2511c726f26'),
        new GenericElement('BUDDY - Bleu', 'CollectionType', '64479f07b875a2511c726efe'),
        new GenericElement('BUDDY - Camel', 'CollectionType', '64479f07b875a2511c726f02'),
        new GenericElement('BUDDY - Gris', 'CollectionType', '64479f07b875a2511c726f00'),
        new GenericElement('ELEMENTARY - Caramel', 'CollectionType', '64479f07b875a2511c726ef4'),
        new GenericElement('ELEMENTARY - Gris Charbon', 'CollectionType', '64479f07b875a2511c726ef2'),
        new GenericElement('ELEMENTARY - Marron', 'CollectionType', '64479f07b875a2511c726ef0'),
        new GenericElement('ELEMENTARY - Sable', 'CollectionType', '64479f07b875a2511c726eed'),
        new GenericElement('FAKIR - Gris', 'CollectionType', '64479f07b875a2511c726ef6'),
        new GenericElement('FALKOR - Gris Clair Chiné', 'CollectionType', '64479f07b875a2511c726f28'),
        new GenericElement('GALAKTIK - Gris clair', 'CollectionType', '64479f07b875a2511c726efa'),
        new GenericElement('HAZEL - Beige', 'CollectionType', '64479f07b875a2511c726f3c'),
        new GenericElement('MALO - Beige', 'CollectionType', '64479f07b875a2511c726f06'),
        new GenericElement('MALO - Taupe Grisé', 'CollectionType', '64479f07b875a2511c726f08'),
        new GenericElement('MIDNIGHT - Jaune', 'CollectionType', '64479f07b875a2511c726ef8'),
        new GenericElement('MILANO - Beige', 'CollectionType', '64479f07b875a2511c726f56'),
        new GenericElement('MILANO - Bleu Glacier', 'CollectionType', '64479f07b875a2511c726f58'),
        new GenericElement('MILANO - Bleu Pétrole', 'CollectionType', '64479f07b875a2511c726f5a'),
        new GenericElement('MILANO - Gris Anthracite', 'CollectionType', '64479f07b875a2511c726f68'),
        new GenericElement('MILANO - Gris Clair', 'CollectionType', '64479f07b875a2511c726f6a'),
        new GenericElement('MILANO - Jaune Moutarde', 'CollectionType', '64479f07b875a2511c726f6c'),
        new GenericElement('MILANO - Textile Recyclé Gris Clair Chiné', 'CollectionType', '64479f07b875a2511c726f5c'),
        new GenericElement('MILANO - Toile Gris Ardoise', 'CollectionType', '64479f07b875a2511c726f5e'),
        new GenericElement('MILANO - Toile Gris Clair', 'CollectionType', '64479f07b875a2511c726f60'),
        new GenericElement('MILANO - Toile Gris Taupe', 'CollectionType', '64479f07b875a2511c726f62'),
        new GenericElement('MILANO - Toile Ivoire', 'CollectionType', '64479f07b875a2511c726f64'),
        new GenericElement('MILANO - Toile Mastic', 'CollectionType', '64479f07b875a2511c726f66'),
        new GenericElement('NEO JOHN - Cuir Marron', 'CollectionType', '64479f07b875a2511c726f3a'),
        new GenericElement('POMPEI - Lin', 'CollectionType', '64479f07b875a2511c726f0e'),
        new GenericElement('POMPEI - Lin Blanc', 'CollectionType', '64479f07b875a2511c726f0c'),
        new GenericElement('POMPEI - Lin Bleu Céladon', 'CollectionType', '64479f07b875a2511c726f10'),
        new GenericElement('POMPEI - Lin Bleu Nuit', 'CollectionType', '64479f07b875a2511c726f12'),
        new GenericElement('POMPEI - Lin Epais Gris', 'CollectionType', '64479f07b875a2511c726f22'),
        new GenericElement('POMPEI - Lin Froissé Marron Havane', 'CollectionType', '64479f07b875a2511c726f14'),
        new GenericElement('POMPEI - Lin Froissé Orange de Sienne', 'CollectionType', '64479f07b875a2511c726f16'),
        new GenericElement('POMPEI - Lin Froissé Vert', 'CollectionType', '64479f07b875a2511c726f18'),
        new GenericElement('POMPEI - Lin Gris  Anthracite', 'CollectionType', '64479f07b875a2511c726f1a'),
        new GenericElement('POMPEI - Lin Supérieur Beige', 'CollectionType', '64479f07b875a2511c726f1e'),
        new GenericElement('POMPEI - Lin Supérieur Blanc', 'CollectionType', '64479f07b875a2511c726f1c'),
        new GenericElement('POMPEI - Lin Vert Kaki', 'CollectionType', '64479f07b875a2511c726f20'),
        new GenericElement('PUMP - Sable', 'CollectionType', '64479f07b875a2511c726f04'),
        new GenericElement('TERENCE - Beige', 'CollectionType', '64479f07b875a2511c726f3e'),
        new GenericElement('TERENCE - Bleu Glacier', 'CollectionType', '64479f07b875a2511c726f40'),
        new GenericElement('TERENCE - Bleu Pétrole', 'CollectionType', '64479f07b875a2511c726f42'),
        new GenericElement('TERENCE - Gris Anthracite', 'CollectionType', '64479f07b875a2511c726f50'),
        new GenericElement('TERENCE - Gris Clair', 'CollectionType', '64479f07b875a2511c726f52'),
        new GenericElement('TERENCE - Jaune Moutarde', 'CollectionType', '5fd34d962701f141c3217f71'),
        new GenericElement('TERENCE - Textile Recyclé Gris Clair Chiné', 'CollectionType', '64479f07b875a2511c726f54'),
        new GenericElement('TERENCE - Toile Gris Ardoise', 'CollectionType', '64479f07b875a2511c726f46'),
        new GenericElement('TERENCE - Toile Gris Clair', 'CollectionType', '64479f07b875a2511c726f48'),
        new GenericElement('TERENCE - Toile Gris Taupe', 'CollectionType', '64479f07b875a2511c726f4a'),
        new GenericElement('TERENCE - Toile Ivoire', 'CollectionType', '64479f07b875a2511c726f4c'),
        new GenericElement('TERENCE - Toile Mastic', 'CollectionType', '64479f07b875a2511c726f4e'),
        new GenericElement('VIGO - Ecru', 'CollectionType', '64479f07b875a2511c726f0a'),
        new GenericElement('VIRGILE - Ecru', 'CollectionType', '64479f07b875a2511c726f2a'),
        new GenericElement('VIRGILE - Velours Beige', 'CollectionType', '64479f07b875a2511c726f2c'),
        new GenericElement('VIRGILE - Velours Bleu Nuit', 'CollectionType', '64479f07b875a2511c726f2e'),
        new GenericElement('VIRGILE - Velours Cèdre', 'CollectionType', '64479f07b875a2511c726f38'),
        new GenericElement('VIRGILE - Velours Coloris Bronze', 'CollectionType', '64479f07b875a2511c726f30'),
        new GenericElement('VIRGILE - Velours Gris Anthracite', 'CollectionType', '64479f07b875a2511c726f32'),
        new GenericElement('VIRGILE - Velours Ocre', 'CollectionType', '64479f07b875a2511c726f34'),
        new GenericElement('VIRGILE - Velours Terracotta', 'CollectionType', '64479f07b875a2511c726f36')
    ];

    static storageElementsDepth: StorageElementDepth[] = [
        new StorageElementDepth('Toutes les Profondeurs', null),
        new StorageElementDepth('Profondeur 30cm et moins', 'StorageType', 330, 5),
        new StorageElementDepth('Profondeur 40cm', 'StorageType', 430, 370),
        new StorageElementDepth('Profondeur 55cm et plus', 'StorageType', 1000, 525),
        new StorageElementDepth('Kits dressing', 'StorageType')
    ];

    static storageElementsHeight: StorageElementHeight[] = [
        new StorageElementHeight('Toutes les hauteurs', null, 0),
        new StorageElementHeight('Hauteur 38cm', 'StorageType', 380),
        new StorageElementHeight('Hauteur 76cm', 'StorageType', 760),
        new StorageElementHeight('Hauteur 115cm', 'StorageType', 1150),
        new StorageElementHeight('Hauteur 192cm', 'StorageType', 1920),
        new StorageElementHeight('Hauteur 230cm', 'StorageType', 2300)
    ];

    static storageElementsType: StorageElementType[] = [
        new StorageElementType('Avec et sans plinthes', null),
        new StorageElementType('Sans plinthes', '&q.objectTypeConfig.hasPlinth.eq=false'),
        new StorageElementType('Avec plinthes', '&q.objectTypeConfig.hasPlinth.eq=true')
    ];

    static newKitchenStyle = FiltersWidget.kitchenStyles[0];


    static changeKitchenStyle(arrangementList: any[]) {
        let promise = new Promise<void>((resolve, reject) => {

            if (!FiltersWidget.newKitchenStyle) {
                resolve();
                return;
            }
            var newStyle = FiltersWidget.newKitchenStyle.id;

            AssetManagerServices.changeKitchenStyle(arrangementList, newStyle, undefined, function (result) {
                var oldEntities = [];
                var newEntitiesAndParents = [];
                var planManager = PlanManager.getInstance();

                for (var i = 0; i < arrangementList.length; i++) {
                    var oldArrangement = arrangementList[i];
                    if (!oldArrangement.parent || !oldArrangement.floor) {
                        continue;
                    }

                    if (oldArrangement.isArrangementObjectEntity()) {
                        var entity = result[i].new_object_entity;

                        // No entity tu substitute, continue loop
                        if (!entity) {
                            continue;
                        }

                        oldEntities.push(oldArrangement);

                        // We want the final replacing entity to be same id the original entity
                        entity._id = oldArrangement._id;
                        // End override entity id

                        var position = oldArrangement.position;

                        Savane.math.mat4.copy(entity.transform.localMatrix, oldArrangement.transform.globalMatrix);
                        // Adjust position depending on previous and new object height to keep the bottom of the object at the same place
                        if (oldArrangement.anchor && oldArrangement.anchor[1] === -3) {
                            position[2] += (oldArrangement.height - entity.height) / 2;
                        } else {
                            position[2] -= (oldArrangement.height - entity.height) / 2;
                        }
                        entity.position = position;
                        entity.isAnchorActive = oldArrangement.isAnchorActive;
                        var scale = Savane.math.vec3.create();
                        Savane.math.vec3.set(scale, 1, 1, 1);
                        entity.transform.localScale = scale;

                        // Get parent to attach object to
                        var parent = oldArrangement.parent;
                        // No parent found
                        if (parent === null) {
                            // Fallback find room for this object
                            parent = Savane.roomManager.getRoomAtPosition(entity.position, planManager.world.currentScene.currentFloor);
                            // No parent
                            if (parent === null) {
                                // Fallback with current floor
                                parent = planManager.world.currentScene.currentFloor;
                            }
                        }

                        entity.updateFloorHeightFromAnchor(Savane.roomManager.getRoomAtPosition(entity.position, planManager.world.currentScene.currentFloor), planManager.world.currentScene.currentFloor);

                        newEntitiesAndParents.push({ entity: entity, parent: parent });
                    }
                }

                planManager.executeCommand(new Savane.Commands.ReplaceEntitiesCommand(oldEntities, newEntitiesAndParents));
                resolve();
            });
        });

        return promise;
    };

    static changeStyleBottomKitchen() {
        var entities = FilterGroup.collectCustomizableEntities(PlanManager.getInstance().world.currentScene.currentFloor.iArrangements);

        let kitchenEntities = entities.filter(a => {
            return (
                a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureBottom ||
                a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureColumn
            );
        });
        FiltersWidget.changeKitchenStyle(kitchenEntities);
    };

    static changeStyleTopKitchen() {
        var entities = FilterGroup.collectCustomizableEntities(PlanManager.getInstance().world.currentScene.currentFloor.iArrangements);
        let kitchenEntities = entities.filter(a => (a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureTop));
        FiltersWidget.changeKitchenStyle(kitchenEntities);
    };

    static changeStyleAllKitchen() {
        var entities = FilterGroup.collectCustomizableEntities(PlanManager.getInstance().world.currentScene.currentFloor.iArrangements);

        let kitchenEntities = entities.filter(a => {
            return (
                a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureBottom ||
                a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureTop ||
                a.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureColumn
            );
        });

        FiltersWidget.changeKitchenStyle(kitchenEntities);
    };

    static triggerDesignerFilterSelectionChanged() {
        Savane.eventsManager.instance.dispatch(Savane.Events.DESIGNER_FILTER_SELECTION_CHANGED);
    }

    /**
     * FIXME Maybe use sendEvent with paramsPLAN_STATE_CHANGED
     */
    static setWorktopMode() {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
            instance.changeState(ActionStateEnum.idleDecoration);
        }
        else {
            instance.changeState(ActionStateEnum.DrawWorkTop);
        }
        Savane.eventsManager.instance.dispatch(Savane.Events.FULLSCREEN_CHANGED);
    };

    static decorationDoneAllowed = function () {
        if (FiltersWidget.deliverable && FiltersWidget.deliverable.deliverable_states_id && FiltersWidget.deliverable.designers_step) {
            if (FiltersWidget.deliverable.deliverable_states_id === 7 &&
                FiltersWidget.deliverable.designers_step === 'quality control') {
                return false;
            }

            return FiltersWidget.deliverable.deliverable_states_id === 2 ||
                FiltersWidget.deliverable.deliverable_states_id === 7 ||
                FiltersWidget.deliverable.deliverable_states_id === 5 ||
                FiltersWidget.deliverable.deliverable_states_id === 10 ||
                FiltersWidget.deliverable.deliverable_states_id === 12;
        }

        return true;
    };

    /**
     * Send an event associate with a button in designer tools
     * @param event
     */
    static sendEvent(event: any) {
        Savane.eventsManager.instance.dispatch(event, null);
    };

    static EmitEntityParamEditedEvent(item: any, name?: string) {
        Savane.eventsManager.instance.dispatch(Savane.Events.ENTITY_PARAM_EDITED, {
            id: item.id,
            type: item.entityType,
            entity: item,
            key: name
        });
    }

    static mousedown() {
        Savane.eventsManager.instance.dispatch(Savane.Events.STOP_UPDATING_ENVS);
    };

    /**
     * A tool group has been clicked
     *
     * @param filtersGroup
     */
    static selectFiltersGroup(filtersGroup: FilterGroup) {
        var instance = PlanManager.getInstance();
        if (instance) {
            if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
                instance.changeState(ActionStateEnum.idleDecoration);
                Savane.eventsManager.instance.dispatch(Savane.Events.FULLSCREEN_CHANGED);
            }
        }

        if (FiltersWidget.currentFiltersGroup !== null && FiltersWidget.currentFiltersGroup.id === filtersGroup.id) {
            return; // THIS IS TAB NO UNSELECT
        }

        ObjectTypeFilter.disableObjectFilter();
        // If opening other tab than kitchen tab
        if (filtersGroup.id !== 'kitchen') {
            let instance = PlanManager.getInstance();
            if (!instance) {
                return;
            }

            // If drawing worktop mode, then close the state to go to idleDecoration mode
            if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
                instance.changeState(ActionStateEnum.idleDecoration);
            }
        }
        else {
            if (FilterGroup.allIxinaDoorCoatingNewString === null) {
                KitchenFilterWidget.getInstance().resetDefaultIxinaDoorCoatingString();
            }
        }

        if (filtersGroup.id === 'budgets') {
            FilterGroup.pricesAndSupply = null;

            FilterGroup.getAllObjectPricesAndSupply();
        }

        var currentSVG = FilterGroup.filters.svg;
        // Save filters of the last group
        if (FiltersWidget.currentFiltersGroup !== null) {
            FilterGroup.filters.scroll = $('#tab-parent').scrollTop();
            FilterGroup.saveFilters[FiltersWidget.currentFiltersGroup.id] = FilterGroup.filters;
            FiltersWidget.currentFiltersGroup.destroy();
            FiltersWidget.cacheCameras = [];
            FiltersWidget.cacheLights = [];
            FilterGroup.cache.name = "";
            
        }
        FiltersWidget.currentFiltersGroup = filtersGroup;
        if (FilterGroup.saveFilters !== undefined && FilterGroup.saveFilters[FiltersWidget.currentFiltersGroup.id] !== undefined) {
            FilterGroup.filters = FilterGroup.saveFilters[FiltersWidget.currentFiltersGroup.id];
        } else {
            // Filter Group loaded for the first time
            FilterGroup.filters = {
                style: null,
                roomType: null,
                objectType: null,
                coatingType: null,
                svg: currentSVG,
                tags: null,
                joineryType: null,
                technicalElementType: null,
                showPriority: (AssetManagerServices.ARRMGR_COUNTRY_ID === 175 || AssetManagerServices.ARRMGR_COUNTRY_ID === 176 || AssetManagerServices.ARRMGR_COUNTRY_ID === 177) ? 'MDM' : 'REFERENCED',
                hang: 'ALL',
                showUnavailable: false,
                showForGraphicArtists: false,
                showContentFactory: false,
                showRSE: false,
                showNewObjects: false,
                minRangePrice: 0,
                maxRangePrice: 5000,
                minPrice: 0,
                maxPrice: 5000,
                minRangeWidth: 0,
                maxRangeWidth: 5000,
                minWidth: 0,
                maxWidth: 5000,
                public_pinboards: false,
                sort: { price: 0, width: 0 },
                useColorSearch: false,
                color: '#ff0000',
                scroll: 0,
            };

            // Load default group values
            FilterGroup.filters.showPriority = filtersGroup.showPriority;
            FilterGroup.filters.showUnavailable = filtersGroup.showUnavailable;
            FilterGroup.filters.showForGraphicArtists = filtersGroup.showForGraphicArtists;
            FilterGroup.filters.showContentFactory = filtersGroup.showContentFactory;
            FilterGroup.filters.showRSE = filtersGroup.showRSE;
            FilterGroup.filters.showNewObjects = filtersGroup.showNewObjects;
            FilterGroup.filters.hang = filtersGroup.hang;
            FilterGroup.filters.minRangePrice = filtersGroup.minRangePrice;
            FilterGroup.filters.maxRangePrice = filtersGroup.maxRangePrice;
            FilterGroup.filters.minPrice = filtersGroup.minPrice;
            FilterGroup.filters.maxPrice = filtersGroup.maxPrice;
            FilterGroup.filters.minRangeWidth = filtersGroup.minRangeWidth;
            FilterGroup.filters.maxRangeWidth = filtersGroup.maxRangeWidth;
            FilterGroup.filters.minWidth = filtersGroup.minWidth;
            FilterGroup.filters.maxWidth = filtersGroup.maxWidth;
            FilterGroup.filters.sort = filtersGroup.sort;
            FilterGroup.filters.universes = filtersGroup.universes;
            FilterGroup.filters.public_pinboards = filtersGroup.public_pinboards;
            FilterGroup.filters.public_groups = filtersGroup.public_groups;

            switch (filtersGroup.id) {
                case 'kitchen':
                    FilterGroup.filters.kitchenElement = FilterGroup.filters.kitchenElement ?? FiltersWidget.kitchenElements[1];
                    break;

                case 'storage':
                    FilterGroup.filters.storageElementDepth = FilterGroup.filters.storageElementDepth ?? FiltersWidget.storageElementsDepth[2];
                    FilterGroup.filters.storageElementHeight = FilterGroup.filters.storageElementHeight ?? FiltersWidget.storageElementsHeight[0];
                    FilterGroup.filters.storageElementType = FilterGroup.filters.storageElementType ?? FiltersWidget.storageElementsType[0];
                    break;
            }
        }

        if (FilterGroup.filters.previousPage) {
            FilterGroup.currentPage = FilterGroup.filters.previousPage;
        }

        if (FilterGroup.filters.scroll !== undefined) {
            setTimeout(() => {
                $('#tab-parent').scrollTop(FilterGroup.filters.scroll);
            }, 50);
        }

        FiltersWidget.getDecorationService().usedInProject = false;
        FiltersWidget.getDecorationService().displayGroups = false;

        if (filtersGroup.id === "style") {
            FiltersWidget.getDecorationService().displayGroups = true;//user.platforms_id !== 1;
        }

        // The tabs don't have specific results when you switch to them, keep old results shown.
        const keepResultGroups = ['style', 'lights', 'budgets', 'cameras'];
        FiltersWidget.getDecorationService().tabId = filtersGroup.id;
        if (!keepResultGroups.includes(filtersGroup.id)) {
            FiltersWidget.getDecorationService().setFilters(filtersGroup.resource, filtersGroup.generateStringFilter());
        }
        Savane.eventsManager.instance.dispatch(FiltersWidget.getDecorationService().FILTERS_TAB_CHANGED);

        setTimeout(function () {
            FiltersWidget.updateNavBarHtml();
            if (!FiltersWidget.currentFiltersGroup) {
                return;
            }

            FiltersWidget.currentFiltersGroup.html();
            if (FiltersWidget.currentFiltersGroup!.id == "lights") {
                for (let i = 0; i < FiltersWidget.cacheLights.length; ++i) {
                    FiltersWidget.initLightColorPicker(FiltersWidget.cacheLights[i]);
                }
            } else {
                FiltersWidget.initSliders();
                FiltersWidget.initColorPicker();
            }
            Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
        });
    };

    static initSliders() {
        let priceRangeSlider = document.getElementById('priceRangeInput') as noUiSlider.target;

        if (priceRangeSlider) {
            if (priceRangeSlider.noUiSlider) {
                priceRangeSlider.noUiSlider.destroy();
            }
            noUiSlider.create(priceRangeSlider, {
                start: [FilterGroup.filters.minPrice, FilterGroup.filters.maxPrice],
                connect: true,
                step: 10,
                range: {
                    'min': FilterGroup.filters.minRangePrice,
                    'max': FilterGroup.filters.maxRangePrice
                }
            });
            priceRangeSlider.noUiSlider!.on('update', function (values, _handle) {
                if (Number.isNaN(values[0]) || Number.isNaN(values[1])) return;
                if (FilterGroup.filters.minPrice === Number(values[0]) && FilterGroup.filters.maxPrice === Number(values[1])) return;
                FilterGroup.filters.minPrice = Number(values[0]);
                FilterGroup.filters.maxPrice = Number(values[1]);
                $('#priceMin').text(FilterGroup.getMinPrice());
                $('#priceMax').text(FilterGroup.getMaxPrice());
                FilterGroup.updateFilters(FilterGroup.filters);
            });
        }

        let widthRange = document.getElementById('widthRangeInput') as noUiSlider.target;
        if (widthRange) {
            if (widthRange.noUiSlider) {
                widthRange.noUiSlider.destroy();
            }
            noUiSlider.create(widthRange, {
                start: [FilterGroup.filters.minWidth, FilterGroup.filters.maxWidth],
                connect: true,
                step: 10,
                range: {
                    'min': FilterGroup.filters.minRangeWidth,
                    'max': FilterGroup.filters.maxRangeWidth
                }
            });

            widthRange.noUiSlider!.on('update', function (values, _handle) {
                if (Number.isNaN(values[0]) || Number.isNaN(values[1])) return;
                if (FilterGroup.filters.minWidth === Number(values[0]) && FilterGroup.filters.maxWidth === Number(values[1])) return;
                FilterGroup.filters.minWidth = Number(values[0]);
                FilterGroup.filters.maxWidth = Number(values[1]);
                $('#widthMin').text(FilterGroup.getMinWidth());
                $('#widthMax').text(FilterGroup.getMaxWidth());
                FilterGroup.updateFilters(FilterGroup.filters);
            });
        }
    }

    static updateColor(value: any) {
        FilterGroup.filters.color = value.toHex();
        FilterGroup.filters.useColorSearch = true;
        FilterGroup.getUpdateFunctions(FiltersWidget.currentFiltersGroup!.filtersFunction)(FilterGroup.filters);
    };

    static initLightColorPicker(item) {
        if (item.temperature !== Savane.SceneConstants.LightTemperature.color) return;
        if (!$('.color-picker-' + item.id)[0]) return;
        setTimeout(function () {
            ($('.color-picker-' + item.id) as any).spectrum({
                preferredFormat: 'hex',
                color: item.lightColor,
                showInput: true,
                showButtons: false,
                move: function (value) {
                    item.lightColor = value.toHex();
                }
            });
        });
    }

    static initColorPicker() {
        if (!$('.color-picker')[0]) return;
        ($('.color-picker') as any).spectrum({
            preferredFormat: 'hex',
            color: FilterGroup.filters.color || '#f00',
            showInput: true,
            showButtons: false,
            move: FiltersWidget.updateColor
        });
    }

    //init nouislider
    static interval = setInterval(() => {
        if (!FilterGroup.$rootScope || !FilterGroup.$rootScope.CocosInitialized) {
            return;
        }

        FilterGroup.startSelectionWatcher();

        setTimeout(function () {
            FiltersWidget.initSliders();
            FiltersWidget.initColorPicker();
        });

        clearInterval(FiltersWidget.interval);
    }, 100);

    static tabParentID: string = 'tab-parent';
    static parentId: string;

    static start(parentID: string, $rootScope: any, openPreviewFunc?: Function,
        user?: any, deliverable?: any, $routeParams?: any, designer?: any) {
        FiltersWidget.controller = new FiltersController();
        FiltersWidget.$routeParams = $routeParams;
        FilterGroup.$rootScope = $rootScope;
        FiltersWidget.openPreviewFunc = openPreviewFunc;
        FiltersWidget.user = user;
        FiltersWidget.deliverable = deliverable;
        FiltersWidget.designer = designer;
        FiltersWidget.parentId = parentID;

        FiltersWidget.filterGroups = [
            WidgetFactory.createWidget('assets', this.tabParentID),
            WidgetFactory.createWidget('groups', this.tabParentID),
            WidgetFactory.createWidget('kitchen', this.tabParentID, { kitchenElements: this.kitchenElements }),
            WidgetFactory.createWidget('storage', this.tabParentID, {
                storageElementsDepth: this.storageElementsDepth,
                storageElementsHeight: this.storageElementsHeight,
                storageElementsType: this.storageElementsType
            }),
            WidgetFactory.createWidget('bathroom', this.tabParentID, { bathroomElements: this.bathroomElements }),
            WidgetFactory.createWidget('style', this.tabParentID),
            WidgetFactory.createWidget('coatings', this.tabParentID),
            WidgetFactory.createWidget('pinboards', this.tabParentID),
            WidgetFactory.createWidget('cameras', this.tabParentID),
            WidgetFactory.createWidget('lights', this.tabParentID),
            WidgetFactory.createWidget('budgets', this.tabParentID),
            WidgetFactory.createWidget('magicsearch', this.tabParentID),
        ];

        if (!FiltersWidget.user) {
            //init a default B2B owner
            FiltersWidget.user = {
                platforms_id: 0 // Or 1 for B2C
            };
        }
        else {
            // Check if owner needs additional cameras or not (to hide the add camera button)
            if (FiltersWidget.user.platform.enable_additionals_afters !== undefined && FiltersWidget.user.platform.enable_additionals_afters === 0) {
                FiltersWidget.enable_additionals_afters = false;
            }
            AssetManagerServices.isUserAllowedToManageAssetsGroupsList(FiltersWidget.user.mail, function (result: any) {
                FiltersWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList = result;
            });
            FiltersWidget.contentFactory = FiltersWidget.user.customers_groups_id === 193 || FiltersWidget.user.mail.indexOf("@rhinov.fr") !== -1;
            FilterGroup.mdmBusiness = FiltersWidget.user.customers_groups_id === 192;
        }

        if (!FiltersWidget.deliverable) {
            // init a default room type to "Piece de vie" if it is missing in the call to designer filters
            FiltersWidget.deliverable = {
                room_type: 17
            };
        }

        FilterGroup.resultListener = Savane.eventsManager.instance.addListener(FiltersWidget.getDecorationService().ASK_FILTERS, function () {
            FilterGroup.updateFilters(FilterGroup.filters);
        });

        FiltersWidget.tulipActionListener = Savane.eventsManager.instance.addListener(Savane.Events.ACTIONS_COUNT_CHANGE, function (event) {
            LightsFilterWidget.getInstance().lightsUpdated();
        });

        FiltersWidget.commandListener = Savane.eventsManager.instance.addListener(Savane.Events.COMMAND_EXECUTED, function (event) {
            // Depending on the command name (see Command.js from CocosPlanModule/src/cocos/scripts/command)
            switch (event.userData.name) {
                case Savane.Commands.CommandEnum.AddEntityCommand:
                case Savane.Commands.CommandEnum.DeleteEntityCommand:
                    if (FilterGroup.isKitchenArrangement(event.userData.datas.entity)) {
                        KitchenTypeFilter.getEntireKitchenPrice();
                        KitchenFilterWidget.getInstance().updateAllActiveLists();
                    }
                    if (FilterGroup.isStorageArrangement(event.userData.datas.entity)) {
                        StorageFilterWidget.getInstance().updateAllActiveLists();
                    }
                    if (FilterGroup.isBathroomArrangement(event.userData.datas.entity)) {
                        BathRoomFilterWidget.getInstance().updateAllActiveLists();
                    }
                    if (event.userData.datas.entity.lightOn !== undefined) {
                        FiltersWidget.cacheLights = [];
                        LightsFilterWidget.getInstance().lightsUpdated();
                    }
                    if (event.userData.datas.entity.isRenderCameraEntity()) {
                        FiltersWidget.cacheCameras = [];
                        CamerasFilterWidget.getInstance().camerasUpdated();
                    }
                    if (FiltersWidget.currentFiltersGroup!.id === 'budgets') {
                        FilterGroup.getAllObjectPricesAndSupply();
                    }
                    break;

                case Savane.Commands.CommandEnum.EditRenderCameraCommand:
                    FiltersWidget.cacheCameras = [];
                    CamerasFilterWidget.getInstance().camerasUpdated();
                    break;

                case Savane.Commands.CommandEnum.ChangeKitchenCoatingCommand:
                    KitchenTypeFilter.getEntireKitchenPrice();
                    break;
            }
        });

        FiltersWidget.projectReloadListener = Savane.eventsManager.instance.addListener(Savane.Events.PROJECT_RELOAD, function () {
            FiltersWidget.cacheLights = [];
            FiltersWidget.cacheCameras = [];
            FilterGroup.cache.name = "";
        });

        if ($routeParams && $routeParams.deliverableId) {
            let uri = (typeof HP_CONFIG !== 'undefined') ? HP_CONFIG.APIUri : '//api.rhinovplanner.com/';
            let url = uri + 'bo/deliverables/' + $routeParams.deliverableId + '/answers/furnitures';
            Savane.HttpService.get(url).then(function (response: any) {
                FiltersWidget.furnitures = response.data;
            });
        }

        let keydownListener = function (event: KeyboardEvent) {
            if ((event.ctrlKey || event.shiftKey && event.ctrlKey) && event.keyCode == 90) {
                // ctrl + z - ctrl + shift + z
                event.preventDefault();
            }
        }

        document.addEventListener("keydown", keydownListener);
        FiltersWidget.keyDownListener = keydownListener;

        FiltersWidget.html();
        FiltersWidget.selectFiltersGroup(FiltersWidget.filterGroups[0]);
        return new FiltersWidget();
    }

    static navbarHtml() {
        let html = '';

        FiltersWidget.filterGroups.forEach((filterGroup) => {
            let active = FiltersWidget.currentFiltersGroup && filterGroup.id === FiltersWidget.currentFiltersGroup.id;
            html += `
                <li id="${filterGroup.id}" class="filterGroup-tab ${active ? 'active' : ''}">
                    <a href="javascript:void(0)">
                        <div title="${filterGroup.name}">
                            <i class="${filterGroup.icon}" aria-hidden="true"></i>
                        </div>
                    </a>
                </li>
            `;
        });

        setTimeout(() => {
            if (!FiltersWidget.controller) {
                return;
            }
            FiltersWidget.controller.addEventListeners('click', (evt) => {

                let target = evt.currentTarget as HTMLElement;
                let group = FiltersWidget.filterGroups.find((group) => group.id === target.id);
                if (group) {
                    FiltersWidget.selectFiltersGroup(group);
                } else {
                    console.error(`Group with id ${target.id} not found`);
                }
            }, 'filterGroup-tab');
        }, 50);

        return html;
    }

    static updateNavBarHtml(): void {
        const navbar = document.getElementById('Filters-navBar');
        if (!navbar) {
            return;
        }

        if (FiltersWidget.controller && Object.keys(FiltersWidget.controller.listeners).length !== 0) {
            FiltersWidget.controller.removeEventListeners('click', 'filterGroup-tab');
            console.log("Listeners removed");
        }
        navbar.innerHTML = FiltersWidget.navbarHtml();
    }

    static html(delta: number = 0) {

        if (!$('#' + FiltersWidget.parentId)[0]) {
            if (delta >= 250) {
                toastr.error('Impossible de charger le widget de filtres');
                return;
            };
            // If the parentId is not found, try again after a delay
            setTimeout(() => {
                FiltersWidget.controller.destroy();
                FiltersWidget.html(delta + 50);
            }, 50);
            return;
        }

        setTimeout(() => {
            if (FiltersWidget.controller) {
                FiltersWidget.controller.addEventListener('mousedown', FiltersWidget.mousedown, 'planFiltersGroupsBar');
            }
        }, 50);

        const container = document.getElementById(FiltersWidget.parentId);
        if (!container) {
            return;
        }

        container.innerHTML = `
        <div id="planFiltersGroupsBar" style="user-select:none">
            <ul id="Filters-navBar" class="nav nav-tabs nav-justified"></ul>
            <div class="tab-content">
                <div class="tab-pane active">
                    <div style="max-height: 250px; overflow: auto; display:flex; flex-direction:column" id="tab-parent" tabindex="-1">
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    static destroy() {
        Savane.eventsManager.instance.removeListener(FiltersWidget.commandListener);
        Savane.eventsManager.instance.removeListener(FiltersWidget.projectReloadListener);
        Savane.eventsManager.instance.removeListener(FiltersWidget.designerFiltersNextObjects);
        Savane.eventsManager.instance.removeListener(FiltersWidget.webGLActiveCameraListener);
        Savane.eventsManager.instance.removeListener(FiltersWidget.webGLFreeCameraListener);
        Savane.eventsManager.instance.removeListener(FiltersWidget.tulipActionListener);

        if (FiltersWidget.keyDownListener) {
            document.removeEventListener("keydown", FiltersWidget.keyDownListener);
        }
        FiltersWidget.keyDownListener = null;

        if (FiltersWidget.currentFiltersGroup) {
            FiltersWidget.currentFiltersGroup.destroy();
        }
        FiltersWidget.currentFiltersGroup = null;

        const parent = document.getElementById(FiltersWidget.tabParentID);
        if (parent) parent.innerHTML = "";

        const navBar = document.getElementById('Filters-navBar');
        if (navBar) navBar.innerHTML = "";

        ($('.color-picker') as any).spectrum('destroy');

        FiltersWidget.cacheLights = [];
        FiltersWidget.cacheCameras = [];
        FiltersWidget.controller.destroy();
        FiltersWidget.controller = null;
        FiltersWidget.$routeParams = null;
        FiltersWidget.user = null;
        FiltersWidget.designer = null;
        FiltersWidget.openPreviewFunc = null;
        FiltersWidget.deliverable = null;

        FilterGroup.$rootScope = null;
    }
}